import { render, staticRenderFns } from "./intHotelInfoDetail.vue?vue&type=template&id=69872399&scoped=true&"
import script from "./intHotelInfoDetail.vue?vue&type=script&lang=js&"
export * from "./intHotelInfoDetail.vue?vue&type=script&lang=js&"
import style0 from "./intHotelInfoDetail.vue?vue&type=style&index=0&id=69872399&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "69872399",
  null
  
)

export default component.exports